import React, { useState } from 'react';
import { useProjectsService, Project } from 'nekst-api';
import { useParams } from 'react-router-dom';
import InnerBlock from '../../shared/web/layout/InnerBlock';
import ClientPortalConfigurationForm, { FormButtonsPortal } from './ClientPortalConfigurationForm';
import useDataLoader from '../../shared/uibuilder/form/dataLoader';
import LoadingAnimation from '../../shared/LoadingAnimation';
import TextField from '../../shared/uibuilder/show/field/TextField';
import ProjectPagesButtons from '../view/ProjectPagesButtons';
import MainBlock from '../../shared/web/layout/MainBlock';
import { ProjectBreadcrumb } from '../view/ProjectContext';
import { Breadcrumb } from '../../shared/web/layout/Breadcrumbs';
import { CopyClientPortalLinkPortal } from './CopyClientPortalLinkButton';
import { OpenPortalPreviewPortal } from './OpenPortalPreview';
import { ProjectTypeField } from 'features/tasks-forms';

function ClientPortalConfigurationBreadcrumbs() {
  return (
    <ProjectBreadcrumb>
      <Breadcrumb text="Client Portal Configuration" />
    </ProjectBreadcrumb>
  );
}

export default function ClientPortalConfigurationPage() {
  const params = useParams();

  const [project, setProject] = useState<Project>();

  const projectService = useProjectsService();

  useDataLoader(
    () => projectService.getById(parseInt(params.id!, 10)),
    setProject,
  );

  if (project) {
    return (
      <>
        <ClientPortalConfigurationBreadcrumbs />
        <MainBlock
          title={<TextField source="name" />}
          titleLine2={<ProjectTypeField />}
          headerRight={(
            <>
              <FormButtonsPortal />
              <OpenPortalPreviewPortal />
              <CopyClientPortalLinkPortal />
              <ProjectPagesButtons />
            </>
          )}
        >
          <InnerBlock title="Client Portal Configuration">
            <ClientPortalConfigurationForm project={project} />
          </InnerBlock>
        </MainBlock>
      </>
    );
  } else {
    return <LoadingAnimation isBig />;
  }
}
